import {
    forEach,
    array2map
} from "../../common/utils";
import {
    KUser
} from "../../models/user";

export function cleanUser(user) {
    user = KUser(user)
    const {
        uid,
        nick,
        logoSrc
    } = user

    return {
        uid,
        nick,
        logoSrc
    }
}


export function cleanUsers(userList, toMap) {
    const users = []
    forEach(userList, user => {
        user = cleanUser(user)
        if (user.uid > 0) {
            users.push(user)
        }
    })
    return toMap ? array2map(users, 'uid') : users
}
